import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-current-openings',
  templateUrl: './current-openings.component.html',
  styleUrls: ['./current-openings.component.css']
})
export class CurrentOpeningsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  	
  }

}
